import { useSankeyRenderContext } from '../../contexts/sankeyRenderContext';
import { useCurrentUser } from '../../utils/user';

const SankeyWatermark: React.FC = () => {
  const { cfg, graph } = useSankeyRenderContext();
  const { user } = useCurrentUser();

  // Show this tooltip only if the user is not subscribed yet
  const tooltip = !user?.has_active_subscription
    ? 'Removing this watermark requires a subscription'
    : undefined;

  return (
    <text
      textAnchor="middle"
      x={cfg.canvas_width / 2 - graph.leftMargin}
      y={graph.h + cfg.margin.bottom - 12}
      fontSize={cfg.canvas_width < 800 ? '6px' : '10px'}
      fill={cfg.hint.color}
    >
      {tooltip && <title>{tooltip}</title>}
      created with SankeyArt.com
    </text>
  );
};

export default SankeyWatermark;
